import { useEffect, useState } from "react";
import formatDuration from "../../utils/formatDuration/formatDuration";

const useDuration = (startTime) => {
  const [duration, setDuration] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDuration(formatDuration(startTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return duration;
}

export default useDuration;